import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AuthSigninComponent} from './pages/auth-signin/auth-signin.component';
import {IsAuthenticatedAuthGuard} from './auth-guards/is-authenticated-auth-guard';
import {VaultSigninCodeComponent} from './pages/vault-signin-code/vault-signin-code.component';
import {DashboardComponent} from './pages/dashboard/dashboard.component';
import {AppComponent} from './app.component';
import {ConnectedAccountsTabComponent} from './components/connected-accounts-tab/connected-accounts-tab.component';
import {ConnectedAppsTabComponent} from './components/connected-apps-tab/connected-apps-tab.component';
import {SettingsTabComponent} from './components/settings-tab/settings-tab.component';
import {DashboardRoutingModule} from './dashboard-routing.module';
import {IdentityVerificationComponent} from "./pages/identity-verification/identity-verification.component";
import {IdentityVerificationErrorComponent} from "./pages/identity-verification-error/identity-verification-error.component";
import {HealthSystemSearchComponent} from "./pages/health-system-search/health-system-search.component";
import {HealthSystemBrandDetailsComponent} from "./pages/health-system-brand-details/health-system-brand-details.component";
import {HealthSystemConnectingComponent} from "./pages/health-system-connecting/health-system-connecting.component";
import {TestModeRedirectComponent} from './pages/test-mode-redirect/test-mode-redirect.component';
import {FormSupportRequestComponent} from './pages/form-support-request/form-support-request.component';
import {AuthCallbackComponent} from './pages/auth-callback/auth-callback.component';

export const routes: Routes = [
  // @Input routing
  // https://www.freecodecamp.org/news/use-input-for-angular-route-parameters/
  // https://angular.love/router-data-as-components-inputs-in-angular-v16


  { path: 'auth/signin', component: AuthSigninComponent },
  { path: 'auth/callback', component: AuthCallbackComponent },
  { path: 'auth/signin/code', component: VaultSigninCodeComponent },
  { path: 'test', component: TestModeRedirectComponent },
  { path: 'auth/identity/verification', component: IdentityVerificationComponent, }, //canActivate: [IsAuthenticatedAuthGuard] },
  { path: 'auth/identity/verification/error', component: IdentityVerificationErrorComponent}, //canActivate: [IsAuthenticatedAuthGuard] },


  { path: 'search', component: HealthSystemSearchComponent, canActivate: [IsAuthenticatedAuthGuard]  },
  { path: 'brand/details', component: HealthSystemBrandDetailsComponent, canActivate: [IsAuthenticatedAuthGuard]  },
  { path: 'brand/connecting', component: HealthSystemConnectingComponent, canActivate: [IsAuthenticatedAuthGuard] },
  // { path: 'form/healthsystem', component: FormHealthSystemRequestComponent, canActivate: [IsAuthenticatedAuthGuard] },
  { path: 'form/support', component: FormSupportRequestComponent, canActivate: [IsAuthenticatedAuthGuard] },

  { path: '', redirectTo: '/auth/signin', pathMatch: 'full' },

  //must be at bottom of list
  { path: '**', redirectTo: 'auth/signin' },

];


@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    DashboardRoutingModule // this is the magic. I'm assuming to put it second is better (though putting it first didn't seem to have any immediate negative effect)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
